import { modulosWeb, type AbaWeb, type ModuloWeb } from './modulos-web';

/**
 * U15 F0: chave estável de tela, base da ajuda contextual. Formato `<slug do módulo>/<chave da aba>` (ex.:
 * `conversas/whatsapp`) e `inicio` para o Início (`/`). Independe do menu onde a aba mora (projeção de aba não muda a
 * chave) e do idioma. É a mesma `tela_chave` que a aula do Treinamento guarda (`GET /treinamento/ajuda/:tela`).
 */
export const CHAVE_TELA_INICIO = 'inicio';

/** Chave da aba (`<slug>/<chave da aba>`). */
export const chaveDaAba = (modulo: Pick<ModuloWeb, 'slug'>, aba: Pick<AbaWeb, 'chave'>): string => `${modulo.slug}/${aba.chave}`;

/** Chave da tela pelo módulo e aba; sem aba (ou sem módulo) vale o Início. */
export function chaveDaTela(modulo?: Pick<ModuloWeb, 'slug'> | null, aba?: Pick<AbaWeb, 'chave'> | null): string {
  return modulo && aba ? chaveDaAba(modulo, aba) : CHAVE_TELA_INICIO;
}

/** Todas as chaves de tela das abas dos módulos web, mais o Início. */
export function chavesDeTodasAsTelas(lista: readonly ModuloWeb[] = modulosWeb): string[] {
  return [CHAVE_TELA_INICIO, ...lista.flatMap((m) => m.abas.map((a) => chaveDaAba(m, a)))];
}

/** Aba e módulo de uma chave; null quando não existe (o Início também devolve null). */
export function telaDaChave(chave: string, lista: readonly ModuloWeb[] = modulosWeb): { modulo: ModuloWeb; aba: AbaWeb } | null {
  const barra = chave.indexOf('/');
  if (barra <= 0) return null;
  const modulo = lista.find((m) => m.slug === chave.slice(0, barra));
  const aba = modulo?.abas.find((a) => a.chave === chave.slice(barra + 1));
  return modulo && aba ? { modulo, aba } : null;
}

/**
 * Ajustes do CRM 27/10 (K12): a chave da tela aberta pelo caminho, para a aba "Ajuda desta tela" do painel Malgo IA. Página
 * da casca nova (`crm/comercial`) vira `<slug>/<chave da página>`; aba de sempre (`/menu/modulo/aba`), a chave da aba; o
 * resto, o Início.
 */
export function chaveDaTelaPeloCaminho(caminho: string, lista: readonly ModuloWeb[] = modulosWeb): { chave: string; slug: string | null; rotulo: string | null } {
  const limpo = (caminho.split('?')[0] ?? '').replace(/^\/+|\/+$/g, '');
  for (const m of lista) for (const p of m.paginasCasca ?? []) if (limpo === p.caminho || limpo.startsWith(`${p.caminho}/`)) return { chave: `${m.slug}/${p.chave}`, slug: m.slug, rotulo: `casca.${p.chave}` };
  const [, b, c] = limpo.split('/');
  const modulo = lista.find((m) => m.slug === b);
  const aba = modulo?.abas.find((a) => a.chave === c);
  if (modulo && aba) return { chave: chaveDaAba(modulo, aba), slug: modulo.slug, rotulo: `abas.${aba.chave}` };
  return { chave: CHAVE_TELA_INICIO, slug: null, rotulo: null };
}
